import {
  Component,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';

import { BaseModalComponent } from '../_base-modal.component';


@Component({
  moduleId: module.id,
  selector: 'warning-modal',
  templateUrl: 'warning-modal.component.html',
  styleUrls: ['warning-modal.component.scss'],
})
export class WarningModalComponent extends BaseModalComponent {

  @Input() title: string;

  @Input() description: string;

  @Input() iconClass: string;

  @Input() showCheckbox: boolean = false;

  @Output() confirm: EventEmitter<any> = new EventEmitter();

  notShowAgain: boolean = false;

  onConfirmClick() {
    this.confirm.emit(this.notShowAgain);
    this.hide();
  }

  onCheckboxChange(event: any) {
    this.notShowAgain = event.target.checked;
  }
}
